<template>
  <div>
    <label class="text-left block">
      <slot></slot>
    </label>
    <v-select class="w-full rounded-md !shadow w-full !border bg-white border-gray-100 outline-none text-md px-3 py-2 placeholder-gray-600"
      v-if="!disabled && (options instanceof Array)"
      v-model="model"
      label="label"
      :options="arrayOptions"
      :required="required"
      :reduce="option => option.value"
      :disabled="disabled"
      @blur="blurEvent()"
      :multiple="multiple"
    />
    <v-select class=" w-full rounded-md !shadow w-full !border bg-white border-gray-100 outline-none text-md px-3 py-2 placeholder-gray-600"
      v-if="!disabled && !(options instanceof Array)"
      v-model="model"
      label="label"
      :options="arrayOptions"
      :required="required"
      :reduce="option => option.value"
      :disabled="disabled"
      @blur="blurEvent()"
      :multiple="multiple"
    />
    <v-select class="w-full rounded-md !shadow w-full !border bg-gray-100 border-gray-100 outline-none text-md px-3 py-2 placeholder-gray-600 cursor-not-allowed"
      v-if="disabled"
      v-model="model"
      :options="arrayOptions"
      :required="required"
      :reduce="option => option.value"
      :disabled="disabled"
      @blur="blurEvent()"
      :multiple="multiple"
    />
    <InputError
      :label="errorLabel"
      :condition="errorCondition && required && edited"
    />
    <!-- <div>Default Data: {{ defaultValue }}</div>
    <div>model: {{ model }}</div>
    <div>Options: {{ options }}</div>
    <div>ArrayOptions: {{ arrayOptions }}</div> -->
  </div>
</template>


<script>

import InputError from './InputError.vue'

export default {
  props: {
    disabled: Boolean,
    options: undefined,
    value: undefined,
    required: Boolean,
    defaultValue: undefined,
    errorLabel: String,
    errorCondition: Boolean,
    label: undefined,
    val: undefined,
    multiple: Boolean,
  },
  components: {
    InputError
  },
  data() {
    return {
      arrayOptions: [],
      edited: false,
    }
  },
  methods: {
    getOptions() {
      if (this.val !== undefined && this.label !== undefined) {
        let toReturn = []
        for (const option of this.options) {
          toReturn.push({'value': option[this.val], 'label': option[this.label]})
        }
        return toReturn
      }
      else if (this.label !== undefined) {
        let toReturn = []
        for (const option of this.options) {
          toReturn.push({'value': option, 'label': option[this.label]})
        }
        return toReturn
      }
      else {
        let toReturn = []
        for (const option of this.options) {
          if (option instanceof Object) {
            toReturn.push({'value': option.value, 'label': option.label })
          }
          else {
            toReturn.push({'value': option, 'label': option })
          }
        }
        return toReturn
      }
    },
    blurEvent() {
      this.edited = true
    }
  },
  mounted() {
    if (this.options instanceof Array && this.options.length > 0) {
      this.arrayOptions = this.getOptions()
    }
    else {
      this.arrayOptions = []
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(option) {
        this.$emit('input', option)
      }
    }
  },
  watch: {
    options() {
      if (this.options instanceof Array && this.options.length > 0) {
        this.arrayOptions = this.getOptions()
      }
      else {
        this.arrayOptions = []
      }
    },
  }
}
</script>
